<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules" :inline="true">
        <div class="block">
          <div class="contit">基础信息</div>
          <FormItem v-for="(c, i) in formCtrlNo" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">装货信息</div>
          <FormItem v-for="(c, i) in formCtrlIn" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">卸货信息</div>
          <FormItem v-for="(c, i) in formCtrlOut" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">运单信息</div>
          <FormItem v-for="(c, i) in formCtrlOrder.slice(0, 3)" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

          <FormItem v-for="(c, i) in formCtrl2" :key="'form2Item' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange">
            <template #end>
              <!-- 控件后组件 -->
              <div class="switch">
                <el-switch v-model="istime" active-color="#67C23A" :class="istime ? 'active' : 'inactive'"
                  @change="toggleSwitch">
                </el-switch>
                <div class="txt">结款提醒</div>
              </div>
            </template>
          </FormItem>
        </div>
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn :editMode="true" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import nonOrderViewMixin from "./nonOrderViewMixin";

export default {
  mixins: [detailMixin, nonOrderViewMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb: [
        { name: "订单管理", path: "/order/nocontract" },
        { name: "普通订单", path: "/order/nocontract/own/ing" },
        { name: "订单添加" },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

        .switch {
          margin-left: 10px;

          .el-switch {
            display: block;

            .el-switch__core {
              margin: 2px auto;
              display: block;
            }

            &.inactive {
              .el-switch__core::after {
                content: '关';
                line-height: 17px;
                text-indent: 18px;
                color: #fff;
              }
            }

            &.active {
              .el-switch__core::after {
                content: '开';
                line-height: 17px;
                text-indent: -16px;
                color: #fff;
              }
            }
          }

          .txt {
            min-width: 50px;
            line-height: 16px;
            font-size: 12px;
            color: #909399;
            margin-top: 3px;
          }
        }
      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
